import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import { PrimaryLoadingButton } from "../../css components/Button";
import { signInMember } from "../../../redux/slices/memberSlice";

const Card = styled(Box)`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 12px #376fd033;
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px #376fd055;
  }
`;

const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const Description = styled(Typography)`
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
`;

const ExploreButton = styled(PrimaryLoadingButton)`
  background-color: #1a56db;
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
  padding: 6px 16px;

  &:hover {
    background-color: #174dc4;
  }
`;

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  margin: 40px 0;
`;

export default function SegmentCards({
  userID,
  businessEntityID,
  currentBrand,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = sessionStorage.getItem("authToken");
  const [loading, setLoading] = useState({
    new: false,
    existing: false,
  });

  async function handleNavigation(type) {
    setLoading((prev) => ({
      ...prev,
      [type]: true,
    }));
    sessionStorage.setItem("cohortType", type);
    sessionStorage.setItem("role", "NORMAL_USER");

    await dispatch(
      signInMember({
        authToken,
        userID,
        businessEntityId: businessEntityID,
        brandType: currentBrand.type,
        cohortType: type,
      })
    );
    setLoading((prev) => ({
      ...prev,
      [type]: false,
    }));
    if (type === "existing") {
      navigate(pages.audienceList.route);
    }

    if (type === "new") {
      navigate(pages.createAudience.route);
    }
  }

  return (
    <Container>
      <Card>
        <Title>Existing Audience Cohorts</Title>
        <Description>
          Choose from existing audience cohorts tailored to various campaign
          goals and audience behaviours, ready to activate instantly.
        </Description>
        <ExploreButton
          loading={loading.existing}
          onClick={() => handleNavigation("existing")}
          variant="contained"
          disabled={!currentBrand.ID}
        >
          Explore
        </ExploreButton>
      </Card>

      <Card>
        <Title>Create New Audience Cohort</Title>
        <Description>
          Create custom audience cohort tailored to your campaign objectives
          using a wide range of available parameters.
        </Description>
        <ExploreButton
          loading={loading.new}
          onClick={() => handleNavigation("new")}
          variant="contained"
          disabled={!currentBrand.ID}
        >
          Explore
        </ExploreButton>
      </Card>
    </Container>
  );
}
